const theme = ({ palette: { background, error } }) => ({
  background,
  error: {
    color: error.dark,
    borderColor: error.dark
  },
  border: '#c8c8c8'
});

export default theme;
